import { render, staticRenderFns } from "./Coments.vue?vue&type=template&id=fc32db74"
import script from "./Coments.vue?vue&type=script&lang=js"
export * from "./Coments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports